import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { useClassnames } from '@lumapps/classnames';
import { Text, Theme } from '@lumapps/lumx/react';
import type { MetadataReference } from '@lumapps/widget-base/types';

import './index.scss';

const CLASSNAME = 'community-list-metadata';

export interface MetadataListProps {
    displayMetadataParent?: boolean;
    metadataList: MetadataReference[];
    theme?: Theme;
}

export const MetadataList = ({ displayMetadataParent = false, metadataList, theme: themeProp }: MetadataListProps) => {
    const { block, element } = useClassnames(CLASSNAME);

    // in legacy context, theme can be an empty string, so the default prop value doesn't work
    const theme = themeProp || Theme.light;

    if (isEmpty(metadataList)) {
        return null;
    }

    return (
        <ul className={block(`theme-${theme}`)}>
            {metadataList?.map(({ metadataId: id, name, rootName }) => (
                <li key={id}>
                    <Text as="span" className={element('item', `theme-${theme}`)}>
                        <Text as="span" truncate>
                            {rootName && displayMetadataParent ? `${rootName} / ${name}` : `${name}`}
                        </Text>
                    </Text>
                </li>
            ))}
        </ul>
    );
};
